<template>
  <div data-v-6f54e5de="" data-v-2ac6a5fc="" class="content">

    <div data-v-46a773f7="" data-v-6f54e5de="" class="modifyLoginPassword member">
      <form data-v-46a773f7="">
        <div data-v-46a773f7="" class="list">
          <div data-v-46a773f7="" class="form-group">
            <label data-v-46a773f7="">原密码</label>
            <div data-v-46a773f7="" class="input-group">
              <input data-v-46a773f7="" type="password" id="old" v-model="password" placeholder="请输入当前登录密码" maxlength="16" />
              <a data-v-46a773f7="" @click="$parent.openKefu" class="link">忘记密码？</a>
            </div>
          </div>
          <div data-v-46a773f7="" class="form-group">
            <label data-v-46a773f7="">新密码</label>
            <div data-v-46a773f7="" class="input-group">
              <input data-v-46a773f7="" maxlength="16" v-model="paypassword" type="password" placeholder="请输入新的密码" />
            </div>
          </div>
          <div data-v-46a773f7="" class="form-group">
            <label data-v-46a773f7="">确认密码</label>
            <div data-v-46a773f7="" class="input-group">
              <input data-v-46a773f7="" maxlength="16" v-model="paypassword1" type="password" placeholder="请再次输入新密码" />
            </div>
          </div>
        </div>
        <p data-v-46a773f7="">密码由6-16位数字及字母组成</p>
        <a data-v-46a773f7="" class="form-button" @click="isOk()">修改</a>
      </form>
      <div data-v-46a773f7="" class="pay-dialog" style="display: none">
        <div data-v-46a773f7="" slot="alertContent" class="pay-password">
          <div data-v-46a773f7="" class="pay-password__header">提示</div>
          <p data-v-46a773f7="" class="pay-password__title"><span data-v-46a773f7="">请您先绑定手机号后，再修改登录密码</span></p>
          <div data-v-46a773f7=""><a data-v-46a773f7="" href="javascript:void (0);" class="pay-password__button">前往设置</a></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'resetPasswordNew',
  data() {
    return {
      password: null,
      paypassword: null,
      paypassword1: null,
    };
  },
  created() {
    let that = this;
  },
  methods: {
    isOk() {
      let that = this;
      let url = '/api/editPassword';
      let info = {};
      //登录密码
      info.password = that.password;
      info.paypassword = that.paypassword;
      if (!that.password) {
        that.$parent.showTost(0, '请输入旧密码');
        return;
      }
      if (!that.paypassword) {
        that.$parent.showTost(0, '请输入新密码');
        return;
      }
      if (that.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的旧密码长度');
        return;
      }
      if (that.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的新密码长度');
        return;
      }
      if (!that.paypassword1) {
        that.$parent.showTost(0, '请输入确认密码');
        return;
      }
      if (that.paypassword1 != that.paypassword) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (that.password == that.paypassword) {
        that.$parent.showTost(0, '新旧密码不能一致！');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.post(url, info).then(res => {
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        that.$parent.hideLoading();
        if (res.code == 200) {
          that.$parent.showTost(1, res.message);
          localStorage.clear();
          sessionStorage.clear();
          that.$store.commit('changUserInfo');
          that.$store.commit('changToken');
          setTimeout(() => {
            that.$parent.hideLoading();
            that.$parent.goNav('/login')
          }, 1000);
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-01a461a7.8cf42369.css';
@import '../../../static/css/chunk-637cbdfb.a711decf.css';
</style>



// WEBPACK FOOTER //
// src/components/main/resetPasswordNew.vue